import { render, staticRenderFns } from "./ui-textarea.vue?vue&type=template&id=245d4f7a&scoped=true"
import script from "./ui-textarea.vue?vue&type=script&lang=js"
export * from "./ui-textarea.vue?vue&type=script&lang=js"
import style0 from "./ui-textarea.vue?vue&type=style&index=0&id=245d4f7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245d4f7a",
  null
  
)

export default component.exports